/* So this is just global styling for ReactSelect
 * Partial application would cause recreating every select on render.
 */
const selectStyles = {
    control: base => ({
        ...base,
        borderColor: '#aaa',
        borderRadius: 0,
        minHeight: 36,
        minWidth: 100,
        width: '100%',
    }),

    clearIndicator: (base) => {
        return ({
            ...base,
            padding: '0px',
        });
    },

    menu: (base) => {
        return ({
            ...base,
            zIndex: 3,
        });
    },

    option: (base, { data, isFocused, isSelected }) => {
        const backgroundColor = isFocused
            ? '#DEEBFF'
            : isSelected ? 'rgba(0,126,255,.08)' : base.backgroundColor;
        const color = data.active === false
            ? 'red'
            : isSelected ? 'black' : base.color;
        return ({
            ...base,
            backgroundColor,
            color,
        });
    },

    placeholder: (base) => {
        return ({
            ...base,
            color: '#333',
            maxWidth: 'calc(100% - 8px)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        });
    },

};

export default selectStyles;
